import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { GraduationCapIcon, MessageCircleIcon, VideoIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="w-full bg-brand-bg pt-20 md:pt-28 pb-8 md:pb-10 px-6 relative overflow-hidden" data-id="element-148">
      <div className="absolute bottom-0 left-0 right-0 h-[70%] bg-gradient-to-t from-[#22c55e]/10 via-[#22c55e]/5 to-transparent pointer-events-none" data-id="element-149" />
      <div className="absolute -top-[10%] left-1/2 -translate-x-1/2 w-[800px] h-[600px] bg-[#22c55e]/[0.14] rounded-full blur-[120px] pointer-events-none" data-id="element-150" />
      <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-151">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-152">
          <h1 className="text-5xl sm:text-6xl md:text-[5rem] font-bold text-black leading-[1.1] max-w-5xl mx-auto" data-id="element-153">
            Generá tus primeros{' '}
            <span className="text-[#1a8a4a] relative" data-id="element-154">
              ingresos extra
              <span className="absolute -bottom-1 left-0 w-full h-[3px] bg-gray-200 rounded-full" data-id="element-155" />
            </span>{' '}
            vendiendo por internet{' '}
            <span className="text-[#1a8a4a] relative" data-id="element-156">
              desde cero
              <span className="absolute -bottom-1 left-0 w-full h-[3px] bg-gray-200 rounded-full" data-id="element-157" />
            </span>
          </h1>

          {/* Green divider */}
          <div className="flex justify-center mt-8 mb-8" data-id="element-158">
            <div className="w-16 h-1 rounded-full bg-[#1a8a4a]" data-id="element-159" />
          </div>

          <p className="text-[35px] md:text-[40px] text-gray-500 leading-snug max-w-4xl mx-auto" data-id="element-160">
            Transforma tu conocimiento en ingresos reales y empieza a construir
            un negocio digital desde cero, sin complicaciones.
          </p>

          <p className="mt-3 text-lg md:text-xl text-black font-medium max-w-2xl mx-auto" data-id="element-161">
            Te doy el{' '}
            <span className="font-bold text-brand-green" data-id="element-162">VERDADERO</span> paso a
            paso para copiar y pegar.
          </p>
        </motion.div>

        <motion.div className="mt-10" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut',
        delay: 0.15
      }} data-id="element-163">
          <p className="text-lg font-semibold text-brand-green mb-4 uppercase tracking-wider" data-id="element-164">
            Mirá el video 👇
          </p>

          <div className="relative w-full mx-auto rounded-2xl bg-brand-card border border-gray-200 shadow-lg" style={{
          paddingBottom: '65%'
        }} data-id="element-165">
            <iframe src="https://fast.wistia.net/embed/iframe/9dsb5tsk42?seo=true&videoFoam=true" title="Video de presentación" allow="autoplay; fullscreen" allowFullScreen className="absolute top-0 left-0 w-full h-full rounded-2xl" style={{
            border: 'none'
          }} data-id="element-166" />
          </div>

          {/* CTA Button and Feature Cards */}
          <div className="mt-10 flex flex-col items-center" data-id="element-167">
            <a href="https://www.emprende-digital.com/cart/51742249156888:1" target="_blank" rel="noopener noreferrer" className="inline-block bg-brand-green hover:bg-brand-green-hover text-white font-bold text-xl px-16 py-5 rounded-full transition-all duration-300 hover:scale-105 shadow-[0_0_40px_rgba(34,197,94,0.3)] hover:shadow-[0_0_60px_rgba(34,197,94,0.4)]" data-id="element-168">
              🔥 Acceder Ahora
            </a>

            <p className="mt-5 text-gray-600 text-base md:text-lg font-medium" data-id="element-169">
              ⚡ Acceso Inmediato + De 0 a Escalado en Meta
            </p>

            {/* Feature Cards */}
            <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5 w-full max-w-5xl" data-id="element-170">
              <div className="bg-brand-card border border-gray-200 rounded-2xl p-6 text-left shadow-sm" data-id="element-171">
                <div className="flex items-start gap-3 mb-3" data-id="element-172">
                  <div className="w-10 h-10 rounded-full bg-brand-green/15 flex items-center justify-center flex-shrink-0" data-id="element-173">
                    <GraduationCapIcon className="w-5 h-5 text-brand-green" data-id="element-174" />
                  </div>
                  <div data-id="element-175">
                    <h3 className="text-gray-900 font-bold text-base" data-id="element-176">
                      Alumnos con resultados{' '}
                      <span className="text-brand-green" data-id="element-177">REALES</span>
                    </h3>
                  </div>
                </div>
                <p className="text-gray-500 text-sm leading-relaxed" data-id="element-178">
                  Casos comprobados y testimonios verificables.
                </p>
              </div>

              <div className="bg-brand-card border border-gray-200 rounded-2xl p-6 text-left shadow-sm" data-id="element-179">
                <div className="flex items-start gap-3 mb-3" data-id="element-180">
                  <div className="w-10 h-10 rounded-full bg-brand-green/15 flex items-center justify-center flex-shrink-0" data-id="element-181">
                    <MessageCircleIcon className="w-5 h-5 text-brand-green" data-id="element-182" />
                  </div>
                  <div data-id="element-183">
                    <h3 className="text-gray-900 font-bold text-base" data-id="element-184">
                      Comunidad VIP en WhatsApp
                    </h3>
                  </div>
                </div>
                <p className="text-gray-500 text-sm leading-relaxed" data-id="element-185">
                  Soporte cercano y respuesta rápida 24/7.
                </p>
              </div>

              <div className="bg-brand-card border border-gray-200 rounded-2xl p-6 text-left shadow-sm" data-id="element-186">
                <div className="flex items-start gap-3 mb-3" data-id="element-187">
                  <div className="w-10 h-10 rounded-full bg-brand-green/15 flex items-center justify-center flex-shrink-0" data-id="element-188">
                    <VideoIcon className="w-5 h-5 text-brand-green" data-id="element-189" />
                  </div>
                  <div data-id="element-190">
                    <h3 className="text-gray-900 font-bold text-base" data-id="element-191">
                      Mentorías grupales semanales{' '}
                      <span className="text-brand-green" data-id="element-192">EN VIVO</span>
                    </h3>
                  </div>
                </div>
                <p className="text-gray-500 text-sm leading-relaxed" data-id="element-193">
                  Correcciones, estrategia y dudas resueltas en directo.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}